import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import createPersistedState from "vuex-persistedstate"

Vue.use(Vuex, axios)
const APIURL = process.env.NODE_ENV === 'production' ? 'https://ab6hq7fv4b.execute-api.eu-west-1.amazonaws.com/production/se-api/' : 'https://6crydqahcf.execute-api.eu-west-1.amazonaws.com/dev/se-api/';

//-- LEK : Last Evaluated Key

export default new Vuex.Store({
  plugins: [createPersistedState()],
  state: {
    cognitoUser: null,
    url: APIURL,
    enterprise: null,
    status: '',
    ets: '',
    clientname64: '',
    cognitoAccess: null,
    userMail: '',
    role: [],
    manufacturingOrders: [],
    manufacturingOrdersLEK: '',
    productionZones: [],
    productionZonesLEK: '',
    productionZoneLogs: {},
    operators: [],
    operatorsLEK: '',
    products: [],
    productsLEK: '',
    beacons: [],
    beaconsLEK: '',
    filterModalVisible: false,
    searchFavorites: [],
    searchFavSelected: undefined,
    csvFilename: '',
    signedUrl: '',
  },
  mutations: {
    //-- Authentification ------------------------------------------------------------------------------------------------
    authSucceeded: (state, token) => {
      state.status = 'success';
      state.token = token;
    },
    userLogout: (state) => {
      state.status = '';
      state.token = '';
      state.role = [];
    },
    setEnterprise: (state, enterprise) => {
      state.enterprise = enterprise;
      if (enterprise) {
        state.clientname64 = enterprise.id64;
      } else {
        state.clientname64 = null;
      }
    },
    setUser: (state, user) => {
      state.cognitoUser = user;
    },
    //-- Manufacturing orders ------------------------------------------------------------------------------------------------
    updateManufactureOrders(state, manufacturingOrders) {
      state.manufacturingOrders = manufacturingOrders;
    },
    updateManufactureOrdersLEK(state, manufacturingOrdersLEK) {
      state.manufacturingOrdersLEK = manufacturingOrdersLEK;
    },
    addManufactureOrders(state, manufacturingOrders) {
      state.manufacturingOrders = [...state.manufacturingOrders, ...manufacturingOrders];
    },
    editManufacturingOrder(state, manufacturingOrder) {
      let moToEditIndex = state.manufacturingOrders.findIndex( mo => mo.id ===  manufacturingOrder.id);
      Vue.set(state.manufacturingOrders, moToEditIndex, manufacturingOrder);
    },
    deleteManufacturingOrder(state, id) {
      let moToDeleteIndex = state.manufacturingOrders.findIndex( mo => mo.id === id);
      state.manufacturingOrders.splice(moToDeleteIndex, 1);
    },
    refreshManufacturingOrders(state) {
      state.manufacturingOrders = [];
      state.manufacturingOrdersLEK = '';
    },
    switchFilterModalVisible(state, showIt) {
      showIt ? state.filterModalVisible = showIt : state.filterModalVisible = !state.filterModalVisible;
    },
    updateSearchFavorites(state, favs) {
      state.searchFavorites = favs;
    },
    updateSearchFavSelected(state, fav) {
      state.searchFavSelected = fav;
    },
    //-- Production zones ------------------------------------------------------------------------------------------------
    updateProductionZones(state, productionZones) {
      state.productionZones = productionZones;
    },
    updateProductionZonesLEK(state, productionZonesLEK) {
      state.productionZonesLEK = productionZonesLEK;
    },
    addProductionZones(state, productionZones) {
      state.productionZones = [...state.productionZones, ...productionZones];
    },
    editProductionZone(state, productionZone) {
      let moToEditIndex = state.productionZones.findIndex( mo => mo.id ===  productionZone.id);
      Vue.set(state.productionZones, moToEditIndex, productionZone);
    },
    deleteProductionZone(state, id) {
      let moToDeleteIndex = state.productionZones.findIndex( mo => mo.id === id);
      state.productionZones.splice(moToDeleteIndex, 1);
    },
    refreshProductionZones(state) {
      state.productionZones = [];
      state.productionZonesLEK = '';
    },
    setLogsForProductionZone(state, lastProductionZoneLogs) {
      Vue.set(state.productionZoneLogs, lastProductionZoneLogs.zoneId, lastProductionZoneLogs.res);
    },
    //-- Operators ------------------------------------------------------------------------------------------------------------
    updateOperators(state, operators) {
      state.operators = operators;
    },
    updateOperatorsLEK(state, operatorsLEK) {
      state.operatorsLEK = operatorsLEK;
    },
    addOperators(state, operators) {
      state.operators = [...state.operators, ...operators];
    },
    editOperator(state, operator) {
      let moToEditIndex = state.operators.findIndex( mo => mo.id ===  operator.id);
      state.operators[moToEditIndex] = operator;
    },
    deleteOperator(state, id) {
      let moToDeleteIndex = state.operators.findIndex( mo => mo.id === id);
      state.operators.splice(moToDeleteIndex, 1);
    },
    refreshOperators(state) {
      state.operators = [];
      state.operatorsLEK = '';
    },
     //-- Products ------------------------------------------------------------------------------------------------------------
    updateProducts(state, products) {
      state.products = products;
    },
    updateProductsLEK(state, productsLEK) {
      state.productsLEK = productsLEK;
    },
    addProducts(state, products) {
      state.products = [...state.products, ...products];
    },
    editProduct(state, product) {
      let moToEditIndex = state.products.findIndex( mo => mo.id ===  product.id);
      state.products[moToEditIndex] = product;
    },
    deleteProduct(state, id) {
      let productToDeleteIndex = state.products.findIndex( product => product.id === id);
      state.products.splice(productToDeleteIndex, 1);
    },
    refreshProducts(state) {
      state.products = [];
      state.productsLEK = '';
    },
    //-- Beacons ------------------------------------------------------------------------------------------------------------
    updateBeacons(state, beacons) {
      state.beacons = [];
      state.beacons = beacons;
    },
    updateBeaconsLEK(state, beaconsLEK) {
      state.beaconsLEK = beaconsLEK;
    },
    addBeacons(state, beacons) {
      state.beacons = [...state.beacons, ...beacons];
    },
    editBeacon(state, beacon) {
      let beaconToEditIndex = state.beacons.findIndex( beacon => beacon.beaconID ===  beacon.beaconID);
      state.beacons[beaconToEditIndex] = beacon;
    },
    deleteBeacon(state, id) {
      let beaconToDeleteIndex = state.beacons.findIndex( beacon => beacon.beaconID === id);
      state.beacons.splice(beaconToDeleteIndex, 1);
    },
    refreshBeacons(state) {
      state.beacons = [];
      state.beaconsLEK = '';
    },
    //-- CSV - ACTION ------------------------------------------------------------------------------------------------------------
    setCsvFilename(state, filename) {
      state.csvFilename = filename;
    },
    setSignedURL(state, signedUrl) {
      state.signedUrl = signedUrl;
    }
  },
  actions: {
    setUser: (context, user) => {
      context.commit('setUser', user);
    },
    setEnterprise: (context, enterprise) => {
      context.commit('setEnterprise', enterprise);
    },
    //-- Manufacturing orders ---------------------------------------------------------------------------------------------------
    getManufacturingOrders({commit}) {
      if(this.state.manufacturingOrders.length > 0) {
        return;
      } else {
        axios.get(`${APIURL}${this.state.clientname64}/manufacturedorder?limit=1000`).then((response) => {
          response.data.LastEvaluatedKey ? commit('updateManufactureOrdersLEK', response.data.LastEvaluatedKey): commit('updateManufactureOrdersLEK', '');
          commit('updateManufactureOrders', response.data.Items);
        })
      }
    },
    loadMoreManufacturingOrders({commit}) {
      if(this.state.manufacturingOrdersLEK === '') {
        return;
      } else {
        axios.get(`${APIURL}${this.state.clientname64}/manufacturedorder?LastEvaluatedKey=${this.state.manufacturingOrdersLEK.id}`).then((response) => {
          response.data.LastEvaluatedKey ? commit('updateManufactureOrdersLEK', response.data.LastEvaluatedKey) : commit('updateManufactureOrdersLEK', '');
          commit('addManufactureOrders', response.data.Items);
        })
      }
    },
    postManufacturingOrders({commit}, payload) {
      return axios.post(`${APIURL}${this.state.clientname64}/manufacturedorder`, payload).then((response) => {
        if(response.status && [200, 201].includes(response.status)) {
          commit('addManufactureOrders', [response.data]);
          return { 
            message: `${response.data.name} created`,
            type: 'success',
            status: response.status
          }
        } else {
          return {
            message: `Error during the record: ${response.status}`,
            type: 'error',
            status: response.status
          }
        }
      })
    },
    editManufacturingOrder({commit}, payload) {
      return axios.put(`${APIURL}${this.state.clientname64}/manufacturedorder`, payload).then((response) => {
        if(response.status && [200, 201].includes(response.status)) {
          commit('editManufacturingOrder', response.data);
          return { 
            message: `${response.data.name} updated`,
            type: 'success',
            status: response.status
          }
        } else {
          return {
            message: `Error during the record: ${response.status}`,
            type: 'error',
            status: response.status
          }
        }
      })
    },
    deleteManufacturingOrder({commit}, id) {
      axios.delete(`${APIURL}${this.state.clientname64}/manufacturedorder/${id}`).then((response) => {
        if(response.status && [200, 201].includes(response.status)) {
          commit('deleteManufacturingOrder', id);
        } else {
          return {
            message: `Error during the record: ${response.status}`,
            type: 'error',
            status: response.status
          }
        }
      })
    },
    refreshManufacturingOrders({commit, dispatch}) {
      commit('refreshManufacturingOrders');
      dispatch('getManufacturingOrders');
    },
    switchFilterModalVisible({commit}, showIt) {
      commit('switchFilterModalVisible', showIt);
    },
    getManufacturingOrder({commit}, id) {
      axios.get(`${APIURL}manufacturing-order/${id}`).then((response) => {
        commit('updateManufactureOrders', response.data.Items);
      })
    },
    updateSearchFavorites({commit}, favs) {
      commit('updateSearchFavorites', favs)
    },
    updateSearchFavSelected({commit}, fav) {
      commit('updateSearchFavSelected', fav);
    },
    //-- Production zones ------------------------------------------------------------------------------------------------------
    getProductionZones({commit}) {
      if(this.state.productionZones.length > 0) {
        return;
      } else {
        axios.get(`${APIURL}${this.state.clientname64}/productionzone?limit=1000`).then((response) => {
          response.data.LastEvaluatedKey ? commit('updateProductionZonesLEK', response.data.LastEvaluatedKey): commit('updateProductionZonesLEK', '');
          commit('updateProductionZones', response.data.Items);
        })
      }
    },
    
    loadMoreProductionZones({commit}) {
      if(this.state.ProductionZonesLEK === '') {
        return;
      } else {
        axios.get(`${APIURL}${this.state.clientname64}/productionzone?LastEvaluatedKey=${this.state.productionZonesLEK.id}`).then((response) => {
          response.data.LastEvaluatedKey ? commit('updateProductionZonesLEK', response.data.LastEvaluatedKey) : commit('updateProductionZonesLEK', '');
          commit('addProductionZones', response.data.Items);
        })
      }
    },
    
    postProductionZones({commit, state}, payload) {
      return axios.post(`${APIURL}${state.clientname64}/productionzone`, payload).then((response) => {
        if(response.status && [200, 201].includes(response.status)) {
          commit('addProductionZones', [response.data.item]);
          return { 
            message: `${response.data.name} created`,
            type: 'success',
            status: response.status,
            configurationNode: response.data.configurationNode
          }
        } else {
          return {
            message: `Error during the record: ${response.status}`,
            type: 'error',
            status: response.status
          }
        }
      })
    },
    
    editProductionZone({commit}, payload) {
      return axios.put(`${APIURL}${this.state.clientname64}/productionzone/${payload.id}`, payload).then((response) => {
        if(response.status && [200, 201].includes(response.status)) {
          commit('editProductionZone', response.data);
          return { 
            message: `${response.data.name} updated`,
            type: 'success',
            status: response.status
          }
        } else {
          return {
            message: `Error during the record: ${response.status}`,
            type: 'error',
            status: response.status
          }
        }
      })
    },
    
    deleteProductionZone({commit}, id) {
      axios.delete(`${APIURL}${this.state.clientname64}/productionzone/${id}`).then((response) => {
        if(response.status && [200, 201].includes(response.status)) {
          commit('deleteProductionZone', id);
        } else {
          return {
            message: `Error during the record: ${response.status}`,
            type: 'error',
            status: response.status
          }
        }
      })
    },
    
    refreshProductionZones({commit, dispatch}) {
      commit('refreshProductionZones');
      dispatch('getProductionZones');
    },
    
    getProductionZone({commit}, id) {
      axios.get(`${APIURL}${this.state.clientname64}/production-zone/${id}`).then((response) => {
        commit('updateProductionZones', response.data.Items);
      })
    },

    getLogsByProductionZone({commit}, zoneId) {
      axios.get(`${APIURL}${this.state.clientname64}/logsbyzone/${zoneId}`).then((response) => {
        commit('setLogsForProductionZone', {res: response.data.Items, zoneId: zoneId});
      })
    },
    //-- Operators ------------------------------------------------------------------------------------------------------------
    getOperators({commit}) {
      if(this.state.operators.length > 0) {
        return;
      } else {
        axios.get(`${APIURL}${this.state.clientname64}/operator?limit=1000`).then((response) => {
          response.data.LastEvaluatedKey ? commit('updateOperatorsLEK', response.data.LastEvaluatedKey): commit('updateOperatorsLEK', '');
          commit('updateOperators', response.data.Items);
        })
      }
    },
    
    loadMoreOperators({commit}) {
      if(this.state.OperatorsLEK === '') {
        return;
      } else {
        axios.get(`${APIURL}${this.state.clientname64}/operator?LastEvaluatedKey=${this.state.OperatorsLEK.id}`).then((response) => {
          response.data.LastEvaluatedKey ? commit('updateOperatorsLEK', response.data.LastEvaluatedKey) : commit('updateOperatorsLEK', '');
          commit('addOperators', response.data.Items);
        })
      }
    },
    
    postOperators({commit, state}, payload) {
      return axios.post(`${APIURL}${state.clientname64}/operator`, payload).then((response) => {
        if(response.status && [200, 201].includes(response.status)) {
          commit('addOperators', [response.data]);
          return { 
            message: `${response.data.firstname} ${response.data.lastname} created`,
            type: 'success',
            status: response.status
          }
        } else {
          return {
            message: `Error during the record: ${response.status}`,
            type: 'error',
            status: response.status
          }
        }
      })
    },

    editOperator({commit}, payload) {
      return axios.put(`${APIURL}${this.state.clientname64}/operator`, payload).then((response) => {
        if(response.status && [200, 201].includes(response.status)) {
          commit('editOperator', response.data);
          return { 
            message: `${response.data.firstname} ${response.data.lastname} updated`,
            type: 'success',
            status: response.status
          }
        } else {
          return {
            message: `Error during the record: ${response.status}`,
            type: 'error',
            status: response.status
          }
        }
      })
    },
    
    deleteOperator({commit}, id) {
      axios.delete(`${APIURL}${this.state.clientname64}/operator/${id}`).then((response) => {
        if(response.status && [200, 201].includes(response.status)) {
          commit('deleteOperator', id);
        } else {
          return {
            message: `Error during the record: ${response.status}`,
            type: 'error',
            status: response.status
          }
        }
      })
    },
    
    refreshOperators({commit, dispatch}) {
      commit('refreshOperators');
      dispatch('getOperators');
    },
    
    getOperator({commit}, id) {
      axios.get(`${APIURL}${this.state.clientname64}/operator/${id}`).then((response) => {
        commit('updateOperators', response.data.Items);
      })
    },
    //-- Products ------------------------------------------------------------------------------------------------------------
    getProducts({commit}) {
      axios.get(`${APIURL}${this.state.clientname64}/product`).then((response) => {
        response.data.LastEvaluatedKey ? commit('updateProductsLEK', response.data.LastEvaluatedKey): commit('updateProductsLEK', '');
        commit('updateProducts', response.data.Items);
      })
    },
    
    loadMoreProducts({commit}) {
      if(this.state.OperatorsLEK === '') {
        return;
      } else {
        axios.get(`${APIURL}${this.state.clientname64}/product?LastEvaluatedKey=${this.state.productsLEK.id}`).then((response) => {
          response.data.LastEvaluatedKey ? commit('updateProductsLEK', response.data.LastEvaluatedKey) : commit('updateProductsLEK', '');
          commit('addProducts', response.data.Items);
        })
      }
    },
    
    postProduct({commit, state}, payload) {
      return axios.post(`${APIURL}${state.clientname64}/product`, payload).then((response) => {
        if(response.status && [200, 201].includes(response.status)) {
          commit('addProducts', [response.data]);
          return { 
            message: `${response.data.name} created`,
            type: 'success',
            status: response.status
          }
        } else {
          return {
            message: `Error during the record: ${response.status}`,
            type: 'error',
            status: response.status
          }
        }
      })
    },

    editProduct({commit}, payload) {
      return axios.put(`${APIURL}${this.state.clientname64}/product`, payload).then((response) => {
        if(response.status && [200, 201].includes(response.status)) {
          commit('editProduct', response.data);
          return { 
            message: `${response.data.name} updated`,
            type: 'success',
            status: response.status
          }
        } else {
          return {
            message: `Error during the record: ${response.status}`,
            type: 'error',
            status: response.status
          }
        }
      })
    },
    
    deleteProduct({commit}, id) {
      axios.delete(`${APIURL}${this.state.clientname64}/product/${id}`).then((response) => {
        if(response.status && [200, 201].includes(response.status)) {
          commit('deleteProduct', id);
        } else {
          return {
            message: `Error during the record: ${response.status}`,
            type: 'error',
            status: response.status
          }
        }
      })
    },
    
    refreshProducts({commit, dispatch}) {
      commit('refreshProducts');
      dispatch('getProducts');
    },
    
    getProduct({commit}, id) {
      axios.get(`${APIURL}${this.state.clientname64}/product/${id}`).then((response) => {
        commit('updateProducts', response.data.Items);
      })
    },
    //-- Beacons ------------------------------------------------------------------------------------------------------------
    getBeacons({commit}) {
      if(this.state.beacons.length > 0) {
        return;
      } else {
        axios.get(`${APIURL}${this.state.clientname64}/beacons?limit=1000`).then((response) => {
          response.data.LastEvaluatedKey ? commit('updateBeaconsLEK', response.data.LastEvaluatedKey) : commit('updateBeaconsLEK', '');
          commit('updateBeacons', response.data.Items);
        })
      }
    },
    
    loadMoreBeacons({commit}) {
      if(this.state.BeaconsLEK === '') {
        return;
      } else {
        axios.get(`${APIURL}${this.state.clientname64}/beacons?LastEvaluatedKey=${this.state.BeaconsLEK.beaconID}`).then((response) => {
          response.data.LastEvaluatedKey ? commit('updateBeaconsLEK', response.data.LastEvaluatedKey) : commit('updateBeaconsLEK', '');
          commit('addBeacons', response.data.Items);
        })
      }
    },
    
    postBeacon({commit, state}, payload) {
      return axios.post(`${APIURL}${state.clientname64}/beacons`, payload).then((response) => {
        if(response.status && [200, 201].includes(response.status)) {
          commit('addBeacons', [response.data]);
          return { 
            message: `${response.data.beaconShortID} created`,
            type: 'success',
            status: response.status
          }
        } else {
          return {
            message: `Error during the record: ${response.status}`,
            type: 'error',
            status: response.status
          }
        }
      })
    },

    editBeacon({commit}, payload) {
      return axios.put(`${APIURL}${this.state.clientname64}/beacons`, payload).then((response) => {
        if(response.status && [200, 201].includes(response.status)) {
          commit('editBeacon', response.data);
          return { 
            message: `${response.data.beaconShortID} updated`,
            type: 'success',
            status: response.status
          }
        } else {
          return {
            message: `Error during the record: ${response.status}`,
            type: 'error',
            status: response.status
          }
        }
      })
    },
    
    deleteBeacon({commit}, id) {
      axios.delete(`${APIURL}${this.state.clientname64}/beacons/${id}`).then((response) => {
        if(response.status && [200, 201].includes(response.status)) {
          commit('deleteBeacon', id);
        } else {
          return {
            message: `Error during the record: ${response.status}`,
            type: 'error',
            status: response.status
          }
        }
      })
    },
    refreshBeacons({commit, dispatch}) {
      commit('refreshBeacons');
      dispatch('getBeacons');
    },
    //-- CSV - ACTION ------------------------------------------------------------------------------------------------------------
    getCSV({commit}, csvData) {
      axios.get(`${APIURL}${this.state.clientname64}/generatecsv?start=${csvData.start}&end=${csvData.end}`)
        .then( response => {
          commit('setCsvFilename', response.data.filename);
        })
    },
    getSignedUrl({state}) {
      return axios.get(`${APIURL}${this.state.clientname64}/getfile/${state.csvFilename}`)
        .then( response => {
          let element = document.createElement('a');
          element.setAttribute('href',`${response.data.url}`);
          element.setAttribute('download', "data.csv");
          element.style.display = 'none';
          document.body.appendChild(element);
          element.click();
          document.body.removeChild(element);
          return 'download done';
        })
        .catch( err => console.error('The file is not ready: ', err));
    }
  },
  getters: {
    url: state => state.url,
    cognitoUser: state => state.cognitoUser,
    enterprise: state => state.enterprise,
    isAuthenticated: state => state.cognitoUser !== null,
    authStatus: state => state.status,
    isSuperAdmin: state => (state.cognitoUser)?state.cognitoUser.info['cognito:groups'].includes('superadmin'):false,
    getCognitoAccess: state => state.cognitoAccess,
    getUserMail: state => (state.cognitoUser)?state.cognitoUser.info.email:null,
    //-- Manufacturing orders ------------------------------------------------------------------------------------------------
    manufacturingOrders: state => {
      return state.manufacturingOrders;
    },
    isAllManufacturingOrdersLoaded: state => {
      return state.manufacturingOrdersLEK === '';
    },
    manufacturingOrderAssociated(state) {
      return id => state.manufacturingOrders.filter( mo => {
        return  mo.productionZone == undefined ? false : mo.productionZone.includes(id);
      });
    },
    //-- Production zones ------------------------------------------------------------------------------------------------
    productionZones: state => {
      return state.productionZones;
    },
    isAllProductionZonesLoaded: state => {
      return state.productionZonesLEK === '';
    },
    productionZonesAssociated(state) {
      return id => state.productionZones.find( pz => pz.id === id );
    },
    getProductionZoneNameAssociatedByOf: state => productionZoneList => {
      let productionZoneListForThisOF = [];
      if (productionZoneList !== undefined) {
        productionZoneListForThisOF = state.productionZones.filter( productionZone => {
          return productionZoneList.includes(productionZone.id);
        })
      }
      return productionZoneListForThisOF;
    },
    getBeaconCumulTimeByProductionZone: state => zoneId => {
      if(!state.productionZoneLogs[zoneId]) {
        return;
      }
      const coll = state.productionZoneLogs[zoneId];
      let beaconIdList = {};
      let previousBeaconId = '';
      // console.log('coll: ', coll);
      for (let i = 0; i < coll.length; i += 1) {
        // -- If the beaconId was never saw in the loop, record it.
        if (beaconIdList[coll[i].beaconID] === undefined) {
          beaconIdList[coll[i].beaconID] = 0;
        }
        // -- Add 1 minute on each iteration if the previous beaconId was the same
        if (previousBeaconId === beaconIdList[coll[i].beaconID]) {
          beaconIdList[coll[i].beaconID] += 1;
        }
        previousBeaconId = beaconIdList[coll[i].beaconID];
      }
      let beaconCollection = [];
      for (let [key, value] of Object.entries(beaconIdList)) {
        const beaconMatch = state.beacons.find( beacon => beacon.beaconID === key);
        if(beaconMatch !== undefined && beaconMatch.beaconShortID !== undefined) {
          let beaconObj = {
            shortId: beaconMatch.beaconShortID,
            time: value
          };
          if(beaconObj.time !== 0) {
            beaconCollection.push(beaconObj);
          }
        }
      }
      return beaconCollection;
    },
    //-- Operators ------------------------------------------------------------------------------------------------------------
    operators: state => {
      return state.operators;
    },
    isAllOperatorsLoaded: state => {
      return state.operatorsLEK === '';
    },
    operatorIdGroup: state => {
      const idGroup = {};
      state.operators.forEach( operator => {
        idGroup[operator.id] = operator.group;
      })
      return idGroup;
    },
    operatorBeaconIdGroup: state => {
      const beaconIdGroup = {};
      state.operators.forEach( operator => {
        beaconIdGroup[operator.beaconId] = operator.group;
      })
      return beaconIdGroup;
    },
    //-- Products ------------------------------------------------------------------------------------------------------------
    products: state => {
      return state.products;
    },
    //-- Beacons ------------------------------------------------------------------------------------------------------------
    beacons: state => {
      return state.beacons;
    },
    isAllBeaconsLoaded: state => {
      return state.beaconsLEK === '';
    },
    getBeaconShortId: state => beaconId => {
      const beaconMatch = state.beacons.find( beacon => beacon.beaconID === beaconId);
      return beaconMatch.beaconShortID;
    },
    //-- SUPER FILTER ------------------------------------------------------------------------------------------------------------
    getFilterModalVisible: state => {
      return state.filterModalVisible;
    },
    searchFavorites: state => {
      return state.searchFavorites;
    },
    searchFavSelected: state => {
      return state.searchFavSelected;
    },
    getCsvFilename: state => state.csvFilename,
  }
})
